<template>
    <div class="b-callback-icon-container">
        <img :src="require(`@/assets/img/icons/call.png`)" alt="Заказать обратный звонок" class="b24-web-form-popup-btn-12" />
    </div>
</template>
<script>

    export default {
        name: "BitrixCallbackButton"        
    }

</script>

<style>
        .crm-widget-button-mobile .b-callback-icon-container{
            display: none;
          }

        .b-callback-icon-container{
          position: fixed;
          z-index: 99999;
          bottom: 150px;
          right: 50px;
          animation: callbackAnim 400ms;
          cursor: pointer;
        }


        @keyframes callbackAnim{
              0%{
                  transform: scale(0);
              }

              100%{
                  transform: scale(1);
              }
        }
</style>
